import React, { useEffect, useRef, useState } from "react";
// import blueBanner from "../../../assets/img/EasyToolsImg.svg";
import logo from "../../../assets/img/posLogo.svg";
import menuIcon from "../../../assets/img/menu-homepage.svg";
// import headphoneicon from "../../../assets/img/headPhoneIcon.svg";
import globalIcon from "../../../assets/img/globalIcon.svg";
import { useHistory } from "react-router-dom";
import MenuModal from "./components/MenuModal";
import dropdownIcon from "../../../assets/img/dropdown-homepage.svg";
import { homePagecategories } from "../../../helpers/constants";
import ContactModal from "./components/ContactModal";
import { i18n } from "../private/languageSelector";

const HomeHeader = () => {
  const history = useHistory();
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const [showMenuDialog, setShowMenuDialog] = useState(false);
  const [showIndustries, setShowIndustries] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleShowMenuModal = () => {
    setShowMenuDialog(true);
  };
  const handleHideMenuModal = () => {
    setShowMenuDialog(false);
  };
  const handleShowContactModal = () => {
    setShowContactModal(true);
  };
  const handleHideContactModal = () => {
    setShowContactModal(false);
  };

  const selectedLanguage = localStorage.getItem("language") || "english";
  const handleChangeLanguage = () => {
    let language = selectedLanguage === "english" ? "arabic" : "english";
    localStorage.setItem("language", language);
    window.location.reload();
  };

  const goToPricing = () => {
    history.push("/homePage?section=prices", { showPricing: true });
  };

  const industriesRef = useRef(null);

  const handleOutsideClick = (event) => {
    if (industriesRef.current && !industriesRef.current.contains(event.target)) {
      setShowIndustries(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <div
      className="w-100"
      style={{
        position: "fixed",
        top: "0",
        paddingTop: screenSize > 550 ? "1rem" : "1rem",
        background: "#FFFFFF",
        zIndex: "10",
        boxShadow: "0px 2px 4px 0px #00000040",
      }}
    >
      <div
        className="home-pageheader"
        style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 18px", direction: selectedLanguage === "arabic" ? "rtl" : "ltr" }}
      >
        <div className="d-flex justify-content-center align-items-center mb-4">
          {screenSize <= 1200 ? (
            <div
              style={{ marginRight: selectedLanguage === "english" && "4rem", marginLeft: selectedLanguage === "arabic" && "4rem" }}
              onClick={handleShowMenuModal}
            >
              <img className="cursor-pointer" src={menuIcon} alt="menu-icon" width={25} height={25} />
            </div>
          ) : null}
          <div>
            <img className="home-logo cursor-pointer" width={"160px"} src={logo} alt="logo" onClick={() => history.push("/homePage")} />
          </div>
          <div
            className="header-features"
            style={{
              gap: "31px",
              marginLeft: selectedLanguage === "english" && "51px",
              marginRight: selectedLanguage === "arabic" && "51px",
              marginTop: "13px",
              position: "relative",
            }}
          >
            <p
              style={{ fontWeight: "500", fontSize: "16px", color: "#4F4F4F", cursor: "pointer" }}
              onClick={() => setShowIndustries(!showIndustries)}
            >
              {" "}
              {i18n("HomePage.Industries")} <img src={dropdownIcon} alt="dropdown" />
            </p>
            {showIndustries && (
              <ul
                style={{
                  position: "absolute",
                  top: "3.5rem",
                  // left: "6rem",
                  left: selectedLanguage === "english" && "-1.5rem",
                  right: selectedLanguage === "arabic" && "-1.5rem",
                  marginTop: "4px",
                  backgroundColor: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  listStyle: "none",
                  padding: "8px",
                  width: "170px",
                  zIndex: 100,
                  boxShadow: "0px 4px 20px 0px #00000040",
                  fontSize: 14,
                  color: "#4F4F4F",
                  fontWeight: 400,
                  textAlign: selectedLanguage === "arabic" ? "right" : "left",
                }}
                ref={industriesRef}
              >
                {homePagecategories.map((item) => (
                  <li
                    key={item.id}
                    style={{
                      padding: "6px",
                    }}
                  >
                    {selectedLanguage === "arabic" ? item?.arabicLabel : item.label}
                  </li>
                ))}
              </ul>
            )}
            <p style={{ fontWeight: "500", fontSize: "16px", color: "#4F4F4F", cursor: "pointer" }} onClick={goToPricing}>
              {" "}
              {i18n("HomePage.Prices")}
            </p>
            <p className="cursor-pointer" onClick={() => history.push("/help")} style={{ fontWeight: "500", fontSize: "16px", color: "#4F4F4F" }}>
              {i18n("HomePage.Help")}
            </p>
            <p style={{ fontWeight: "500", fontSize: "16px", color: "#4F4F4F", cursor: "pointer" }} onClick={handleShowContactModal}>
              {" "}
              {i18n("HomePage.Contact")}
            </p>
          </div>
          <div className={`d-flex ${selectedLanguage === "arabic" ? "mr-auto" : "ml-auto"} `}>
            {/* <div
            className="phoneIcon"
            style={{ marginRight: selectedLanguage === "english" && "38px", marginLeft: selectedLanguage === "arabic" && "38px", marginTop: "8px" }}
          >
            <img width={"26px"} height={"26px"} src={headphoneicon} alt="" />
          </div> */}
            {screenSize > 467 ? (
              <div
                className="start-btn"
                style={{
                  marginRight: screenSize > 1200 && selectedLanguage === "english" && "45px",
                  marginLeft: screenSize > 1200 && selectedLanguage === "arabic" && "45px",
                }}
              >
                <button
                  style={{
                    borderRadius: "5px",
                    border: "0",
                    backgroundColor: "#9B51E0",
                    color: "#FFFFFF",
                    padding: "8px 28px",
                    fontWeight: "700",
                    fontSize: "16px",
                  }}
                  onClick={() => history.push("/auth/registration")}
                >
                  {screenSize > 1200 ? i18n("HomePage.TryFatoratyNow") : i18n("HomePage.TryNow")}
                </button>
              </div>
            ) : // <div className="d-flex" style={{ alignItems: "center", position: "relative", bottom: "2px", marginRight: "41px" }}></div>
            null}

            <div
              onClick={() => {
                history.push("/auth/login");
              }}
              className="login-btn"
              style={{
                cursor: "pointer",
                marginTop: "8px",
                color: "#4F4F4F",
                lineHeight: "21.80px",
                fontWeight: "700",
                fontSize: "16px",
                marginRight: selectedLanguage === "english" && "40px",
                marginLeft: selectedLanguage === "arabic" && "40px",
              }}
            >
              {i18n("HomePage.LogIn")}
            </div>
          </div>

          {screenSize < 468 ? (
            <div className="start-btn">
              {/* <button
              style={{
                borderRadius: "5px",
                border: "0",
                backgroundColor: "#9B51E0",
                color: "#FFFFFF",
                padding: "5px 16px",
                fontWeight: "700",
                fontSize: "10px",
              }}
            >
              START NOW
            </button> */}
              <button
                style={{
                  borderRadius: "5px",
                  border: "0",
                  backgroundColor: "#9B51E0",
                  color: "#FFFFFF",
                  padding: "5px 10px",
                  fontWeight: "700",
                  fontSize: "14px",
                  maxHeight: "29px",
                  height: "auto",
                }}
                onClick={() => history.push("/auth/registration")}
              >
                {i18n("HomePage.TryNow")}
              </button>
            </div>
          ) : null}
          {screenSize > 1200 ? (
            <div
              className="d-flex mt-3 cursor-pointer"
              style={{ alignItems: "center", position: "relative", bottom: "6px" }}
              onClick={handleChangeLanguage}
            >
              <span
                className={`${selectedLanguage === "english" ? "mr-1" : "ml-1"}`}
                style={{ fontWeight: "400", fontSize: "16px", color: "#4F4F4F" }}
              >
                {selectedLanguage === "english" ? "العربية" : "English"}
              </span>
              <img src={globalIcon} alt="global" />
            </div>
          ) : null}
        </div>
        <MenuModal
          show={showMenuDialog}
          onHide={handleHideMenuModal}
          setShowContactModal={setShowContactModal}
          goToPricing={() => {
            goToPricing();
            handleHideMenuModal();
          }}
        />
        <ContactModal show={showContactModal} onHide={handleHideContactModal} />
      </div>
    </div>
  );
};

export default HomeHeader;
